import { SVGProps } from 'react';

const Move3D = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 19H5V3m3 3L5 3 2 6m3 13 6-6m7 9 3-3-3-3"
    />
  </svg>
);
export default Move3D;
